import { createSelector } from 'reselect';
import { sortBy } from 'shared-base';
import * as base from './selectors.base';

const types: Record<ProjectType, string> = {
  'asset-pack': 'IconBox',
  playground: 'IconDeviceGamepad',
  scene: 'IconTrees',
};

export const $projects = createSelector(base.$projects, (projects) => {
  return (
    projects
      .map((project) => {
        const { id, type } = project;

        return {
          ...project,
          link: `/editors/${id}`,
          entityIcon: types[type],
        };
      })
      // .filter((project) => project.type !== 'playground')
      .sort(sortBy('modifiedAt', 'desc'))
  );
});
